import { render, staticRenderFns } from "./ReserveLocation.vue?vue&type=template&id=5cb1d9aa&"
import script from "./ReserveLocation.vue?vue&type=script&lang=ts&"
export * from "./ReserveLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports